import { useFieldWorkMode, FieldWorkModeChooser } from "@/lib/fieldWorkMode";
import TruckerHome from "@/components/TruckerHome";
import { TradesFirstRun } from '@/components/trades/TradesOnboarding';
import { useTradeFieldPresentation } from '@/lib/tradeFieldPresentation';
import { TradesFieldToday } from './TradesField';
import Overview from "./Overview";
import TradesOverview from "./TradesOverview";
import { useNavigationPresentation } from "@/lib/tradeNavigation";
import { Button } from "@/components/ui/button";

// Consume the existing tenant-bound projection. Never mount Civil while an
// office profile is unknown, and never run Civil queries in the Trades branch.
export default function OperatingOverview() {
  const { user, pending, trades, refresh } = useNavigationPresentation();
  const field = useTradeFieldPresentation();
  const workMode = useFieldWorkMode();
  if (pending || field.pending) return <div className="p-6" role="status">
    <p className="mb-3 text-sm text-muted-foreground">Loading your workspace…</p>
    <Button variant="outline" onClick={() => refresh()}>Retry</Button>
  </div>;
  if (workMode.dual && !workMode.mode) return <FieldWorkModeChooser />;
  if (workMode.dual && workMode.mode === "trucking") return <TruckerHome />;
  if (field.trades) return <TradesFieldToday key={field.identity} />;
  return trades
    ? <TradesFirstRun key={JSON.stringify([user.org_id, user.id, user.role])}><TradesOverview /></TradesFirstRun>
    : <Overview />;
}
